import { LIMITS } from '@taxwar/content'
import { SIM_HZ } from './ids'

/** Burst allowance: one second's worth of commands. */
const CAPACITY = LIMITS.commandsPerSecondPerPlayer
const REFILL_PER_TICK = LIMITS.commandsPerSecondPerPlayer / SIM_HZ

/**
 * Token bucket over one seat's transport commands (docs/ARCHITECTURE.md §12), shared by every room host. It refills per
 * sim tick, not per wall-clock second, so a paused war admits at most CAPACITY queued commands.
 */
export class CommandBucket {
  private tokens: number = CAPACITY

  refill(): void {
    this.tokens = Math.min(CAPACITY, this.tokens + REFILL_PER_TICK)
  }

  /** Takes one token if available; false means the command is rate limited. */
  tryTake(): boolean {
    if (this.tokens < 1) return false
    this.tokens -= 1
    return true
  }
}
